import { configureStore } from "@reduxjs/toolkit";
import storeReducer from "./slices/storeSlice";
import prizeReducer from "./slices/prizes";
import storeSubscriptionReducer from "./slices/store";
import uiReducer from "./slices/ui/slice";
import billing from "./slices/billing";
import authReducer from "./slices/auth";
import countriesReducer from "./slices/countries/slice";
import notifications from "./slices/notifications/slice";
import locations from "./slices/locations/slice";
import chatReducer from "./slices/chat/slice"
import catalogReducer from "./slices/catalog/slice"
import customerReducer from "./slices/customer/slice"
import vendorReducer from "./slices/vendor/slice"
import ProductReducer from "./slices/product/slice"
import RuleReducer from "./slices/rules/slice"
import audience from "./slices/audience/slice"
import proximityNotifications from "./slices/proximity_notifications/slice"
import userAuth from "./slices/user/slice"
import certificateSlice from "./slices/certificates/slice"
import corporationReducer from "./slices/corporation/slice"
import surveyReducer from "./slices/surveys/slice"
import worldCupReducer from "./slices/worldCup/slice"
import businessReducer from "./slices/business/slice"
import dashboardReducer from "./slices/dashboardProvider/slice"

export const store = configureStore({
  reducer: {
    store: storeReducer,
    prize: prizeReducer,
    storeSubscription: storeSubscriptionReducer,
    ui: uiReducer,
    auth: authReducer,
    billing,
    countries: countriesReducer,
    catalog: catalogReducer,
    chatChannels: chatReducer,
    customer: customerReducer,
    vendor: vendorReducer,
    product: ProductReducer,
    rule: RuleReducer,
    notifications,
    locations,
    audience,
    proximityNotifications,
    userAuth,
    certificate: certificateSlice,
    corporation: corporationReducer,
    surveys: surveyReducer,
    worldCup: worldCupReducer,
    business: businessReducer,
    dashboardProvider: dashboardReducer
  },
});
